<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Student profile' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="row">

      <div class="col-12 col-lg-6">

        <div class="form-group">
          <label>{{'Currently I am' | translate}}</label>
          <select class="form-control" [(ngModel)]="entity.profileType">
            <option *ngFor="let option of profileTypes" [value]="option['value']">
              {{option['name'] | translate}}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>{{'Currently I am looking for' | translate}}</label>
          <select class="form-control" [(ngModel)]="entity.lookingFor">
            <option *ngFor="let option of lookingForData" [value]="option['value']">
              {{option['name'] | translate}}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>{{'First name' | translate}}</label>
          <input class="form-control" autocomplete="off" [(ngModel)]="entity.firstName" />
        </div>

        <div class="form-group">
          <label>{{'Last name' | translate}}</label>
          <input class="form-control" autocomplete="off" [(ngModel)]="entity.lastName" />
        </div>

        <div class="form-group">
          <label>{{'Birthdate' | translate}}</label>
          <app-input-birthdate [(ngModel)]="entity.birthDate" name="birthDate"></app-input-birthdate>
        </div>

        <div class="form-group">
          <label>{{'Reference code' | translate}}</label>
          <input class="form-control" autocomplete="off" [(ngModel)]="entity.referenceCode" />
        </div>

        <div class="form-group">
          <label>{{'Profile strength' | translate}}</label>
          <input type="number" class="form-control" [(ngModel)]="entity.profileStrength" />
        </div>

      </div>

      <div class="col-12 col-lg-6">

        <div class="form-group">
          <label>{{'Phone number' | translate}}</label>
          <input class="form-control" autocomplete="off" [(ngModel)]="entity.phoneNumber" />
        </div>

        <div class="form-group">
          <label>{{'Parent email address' | translate}}</label>
          <input class="form-control" autocomplete="off" [(ngModel)]="entity.parentEmailAddress" />
        </div>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" [(ngModel)]="entity.hasParentalConsent" class="custom-control-input" id="hasParentalConsent">
            <label class="custom-control-label" for="hasParentalConsent">{{'Has parental consent' | translate}}</label>
          </div>
        </div>

        <h3>{{'Address' | translate}}</h3>

        <div class="row" *ngIf="entity.homeAddress">

          <div class="col-sm-8">
            <div class="form-group">
              <label>{{'Street' | translate}}</label>
              <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.homeAddress.street" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{'No.' | translate}}</label>
              <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.homeAddress.number" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{'Addition' | translate}}</label>
              <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.homeAddress.numberSuffix" />
            </div>
          </div>

          <div class="col-sm-8">
            <div class="form-group">
              <label>{{'City' | translate}}</label>
              <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.homeAddress.city" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label>{{'Postal code' | translate}}</label>
              <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.homeAddress.postalCode" />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>{{'Country' | translate}}</label>
              <select class="form-control" autocomplete="off" [(ngModel)]="entity.homeAddress.country">
                <option *ngFor="let option of locale.availableCountries()" [value]="option.code">{{option.name}}</option>
              </select>
            </div>
          </div>

          <div class="col-12">

            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" [(ngModel)]="entity.allowEmailNotifications" class="custom-control-input" id="allowEmailNotifications">
                <label class="custom-control-label" for="allowEmailNotifications">{{'I want to get email notifications' | translate}}</label>
              </div>
            </div>

            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" [(ngModel)]="entity.isSubscribedToNewsletter" class="custom-control-input" id="isSubscribedToNewsletter">
                <label class="custom-control-label" for="isSubscribedToNewsletter">{{'I want to receive newsletters' | translate}}</label>
              </div>
            </div>

          </div>

        </div>

      </div>

      <div class="col-12">

        <h3>{{'Field of interest' | translate}}</h3>

        <div class="interests">

          <app-selector-areaofinterests [maxAmount]="maxAmount" [data]="areaOfInterests()" [ngModel]="selectedAreaOfInterests()" (ngModelChange)="selectedAreaOfInterests.set($event)"></app-selector-areaofinterests>

        </div>

      </div>

      <div class="col-12">

        <h3>{{'Tags' | translate}}</h3>

        <app-tag-input
          [suggestions]="tagSuggestions()"
          [allowCreate]="true"
          [placeholder]="'Type to search or add a tag'"
          [(ngModel)]="entity.tags"
        ></app-tag-input>

      </div>

    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button [disabled]="isProcessing" type="button" class="btn btn-primary ml-auto mr-0" (click)="Save()">{{'Save' | translate}} <fa-icon *ngIf="isProcessing" animation="spin" [icon]="faSpinner"></fa-icon></button>
    </div>
  </div>
</div>
